module.exports = __webpack_public_path__ + "img/main-icon.58200b2d.svg";